import { useEffect, useState } from "react";
import { Table, Pagination, Spinner, Container, Modal, Button } from "react-bootstrap";
import { FaBook, FaFileAlt, FaPrint, FaTimes } from "react-icons/fa";
import api from "./api";
import sun from "../images/carrot.png"
import "../styles/homework.css"

const STATUS_MAP = {
  finished: "اتمام یافته",
  ongoing: "در حال برگزاری",
  not_started: "شروع نشده",
};

function shortenAddress(address = "") {
  if (!address) return "";
  if (address.length <= 15) return address;
  return address.slice(0, 15) + "...";
}

const Homework = () => {
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [pageSize] = useState(5);
  const [countPages, setCountPages] = useState(1);
  const [loading, setLoading] = useState(false);
const [courseInfo, setCourseInfo] = useState({ title: "", teacher: "" });
  const [assignments, setAssignments] = useState([]);
  const [showModal, setShowModal] = useState(false);

  const fetchData = async (page) => {
    setLoading(true);
    try {
      const res = await api.get(`/student/api/v1/student-class-home/?page=${page}&page_size=${pageSize}`);
      const json = res.data;
      setData(json.results || []);
      const totalCount = json.count || 0;
      setCountPages(Math.ceil(totalCount / pageSize) || 1);
      setPage(page);
    } catch (error) {
      console.error("Error fetching data:", error);
      setData([]);
      setCountPages(1);
    }
    setLoading(false);
  };

const fetchAssignments = async (classId) => {
  try {
    const res = await api.get(`/student/api/v1/assignments/${classId}`);
    const data = res.data || [];
    setAssignments(data);

    if (data.length > 0) {
      setCourseInfo({
        title: data[0]?.class_session?.course_title || "",
        teacher: data[0]?.class_session?.teacher_full_name || ""
      });
    }
    setShowModal(true);
  } catch (error) {
    console.error("Error fetching assignments:", error);
    setAssignments([]);
    setCourseInfo({ title: "", teacher: "" });
    setShowModal(true);
  }
};

  const handlePageChange = (newPage) => {
    if (newPage < 1 || newPage > countPages) return;
    fetchData(newPage);
  };

  const renderPaginationItems = () => {
    let items = [];
    for (let number = 1; number <= countPages; number++) {
      items.push(
        <Pagination.Item key={number} active={number === page} onClick={() => handlePageChange(number)}>
          {number}
        </Pagination.Item>
      );
    }
   
    return items;
  };

  useEffect(() => {
    fetchData(page);
  }, []);

  return (
    <div className="me-lg-5 px-3 pe-lg-3">
      <div className="mx-5 my-4">
        <span className="fw-bold ms-3"> مشاهده تکالیف</span>
        <img src={sun} width={33} height={33} />
      </div>
      <Container className="my-4  p-3 student-box" style={{ direction: "rtl", maxWidth: "1100px " }}>
        {loading ? (
          <div className="text-center my-5">
            <Spinner animation="border" role="status" />

          </div>
        ) : (
          <>
            <div style={{ overflowX: "auto" }}>
              <Table
                striped
                bordered
                hover
                responsive
                style={{
                  backgroundColor: "white",
                  borderRadius: 8,
                  minWidth: "900px",   // حداقل عرض برای اسکرول
                  textAlign: "center", // همه متن‌ها وسط‌چین
                  verticalAlign: "middle", // عمودی هم وسط
                }}
              >
                <thead>
                  <tr>
                    <th>فعالیت</th>
                    <th>کد کلاس</th>
                    <th>نام کلاس</th>
                    <th>نام استاد</th>
                    <th>زمان کلاس</th>
                    <th>نوع کلاس</th>
                    <th>مشاهده تکالیف</th>
                    <th>جزوه</th>
                  </tr>
                </thead>
                <tbody>
                  {data.length === 0 ? (
                    <tr>
                      <td colSpan={8} className="text-center">
                        داده‌ای برای نمایش وجود ندارد.
                      </td>
                    </tr>
                  ) : (
                    data.map((item, idx) => {
                      const statusText = STATUS_MAP[item.status] || "";
                      const isVirtual = item.class_type !== "in_person";

                      return (
                        <tr key={idx}>
                          <td>{statusText}</td>
                          <td>{item.class_code || ""}</td>
                          <td>{item.class_name || ""}</td>
                          <td>{item.teacher_name || ""}</td>
                          <td>{item.class_time || ""} </td>
                          <td>{isVirtual ? "مجازی" : "حضوری"}</td>
                          <td style={{ cursor: "pointer" }}>
                            <FaBook
                              size={18}
                            onClick={() => fetchAssignments(item.class_code)}
                            />
                          </td>
                          <td>
                            {item.lesson_note && (
                              <a
                                href={item.lesson_note}
                                target="_blank"
                                rel="noopener noreferrer"
                                title="مشاهده جزوه"
                              >
                                <FaFileAlt size={18} />
                              </a>
                            )}
                          </td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </Table>
            </div>




            <div className="mx-5">
              <Pagination className="custom-pagination">
                <Pagination.Prev onClick={() => handlePageChange(page - 1)} disabled={page === 1}>
                  قبلی
                </Pagination.Prev>
                {renderPaginationItems()}
                <Pagination.Next onClick={() => handlePageChange(page + 1)} disabled={page === countPages}>
                  بعدی
                </Pagination.Next>
              </Pagination>
            </div>
          </>
        )}
      </Container>


      <Modal show={showModal} onHide={() => setShowModal(false)} size="lg" centered>
        <Button variant="secondary" className="times" onClick={() => setShowModal(false)}>
          <FaTimes />
        </Button>
        <Modal.Body className="p-lg-5 pt-0" style={{ direction: "rtl" }}>
          <div className="d-flex flex-row justify-content-center align-items-center w-100">
            <div className="homework-header py-2 mx-4 px-3">
              نام دوره :   {courseInfo?.title}
            </div>
            <div className="homework-header py-2 px-3">
              نام مدرس : {courseInfo?.teacher}
            </div>
          </div>
          <div className="row m-lg-5 mt-5 mb-2">
            <div className="col-lg-2 col-3">
              <div className="homework-detail">جلسه </div>
            </div>
            <div className="col-lg-7 col-5"> <div className="homework-detail">توضیحات </div></div>
            <div className="col-lg-3 col-4"> <div className="homework-detail">دانلود فایل </div></div>
          </div>
          {assignments.length === 0 ? (
            <p>هیچ تکلیفی برای این کلاس ثبت نشده است.</p>
          ) : (
            assignments.map((task, i) => (
              <div key={i} >
                <div className="row mx-5 mb-2">
                  <div className="col-2">
                    <div className="homework-detail bg-detail">{task.session_number} </div>
                  </div>
                  <div className="col-7">
                    <div className="homework-detail bg-detail">
                      {task.description.length > 50
                        ? task.description.slice(0, 50) + "..."
                        : task.description}
                    </div>
                  </div>
                  <div className="col-3"> <div className="homework-detail bg-detail d-flex justify-content-center" s>  {task.attachment && (
                    <a href={`${task.attachment_url}`}  rel="noopener noreferrer">
                      <FaPrint />
                    </a>
                  )} </div></div>
                </div>

              </div>
            ))
          )}
        </Modal.Body>

      </Modal>
    </div>
  );
};

export default Homework;
